import { api } from "~/utils/api";
import { useMemo } from "react";

export const useMe = () => {
  const { data, isLoading, refetch, fetchStatus } = api.auth.getSession.useQuery(
    undefined as never
  );
  const user = useMemo(() => {
    if (data) {
      return data?.user;
    }
    return undefined;
  }, [data]);
  const loading = isLoading || fetchStatus === 'fetching';
  return { user, isLoading: loading, refetch };
};
